<template>
  <div class="flex">
    <form-field-select
      :label="label"
      v-model="value.id"
      class="custom_field_select mb-0"
      @change="selectUpdated"
      :validation-errors="validationErrors"
    >
      <!--No custom field-->
      <option :value="null">None</option>

      <!--select existing custom field-->
      <option
        v-for="field in options"
        :key="field.value"
        :value="field.value"
      >{{ field.label }}
      </option>

      <!--create new custom field-->
      <optgroup label="Create">
        <option :value="0">New Custom Field</option>
      </optgroup>
    </form-field-select>

    <!--new custom field label-->
    <form-field-input
      v-if="showNewLabelField"
      label="Custom Field Label"
      v-model="value.label"
      class="ml-200"
      @change="labelUpdated"
    />
  </div>
</template>

<script>
export default {
  name: "LaunchControlCustomFieldSelect",
  props: {
    value: {},
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    validationErrors: {
      type: [
        String,
        Array,
        undefined
      ]
    },
  },
  computed: {
    showNewLabelField() {
      return this.value.id === 0
    },
  },
  methods: {
    selectUpdated(value) {
      this.$emit("input", {
        id: value,
        label: this.value.label,
      });
    },
    labelUpdated(value) {
      this.$emit("input", {
        id: this.value.id,
        label: value,
      });
    }
  },
};
</script>

<style scoped>
.custom_field_select {
  min-width: 240px;
}
</style>
